import React from 'react';
import { Section } from './ui/Section';
import { Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Antes de trabajar con Nacho, mi web era solo un folleto digital. Nadie me escribía. Hoy recibo consultas semanales de personas que me encontraron en Google y se convencieron solas antes de hablar conmigo.',
    author: 'Camila Rojas',
    detail: 'Consultora de Recursos Humanos · Santiago'
  }, {
    quote: 'Subí mis precios un 40% después de lanzar mi nueva web y nadie lo cuestionó. La forma en que me posicioné cambió completamente cómo los clientes me perciben.',
    author: 'Matías Fuentes',
    detail: 'Arquitecto · Viña del Mar'
  }, {
    quote: 'Siempre pensé que una web era un gasto. Ahora entiendo que era la inversión que le faltaba a mi negocio.',
    author: 'Javiera Soto',
    detail: 'Coach de Liderazgo · Concepción'
  }];
  return <Section id="testimonios" className="bg-brand-dark relative overflow-hidden" data-id="element-312">
      {/* Decorative background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-64 bg-brand-accent/5 rounded-[100%] blur-3xl pointer-events-none" data-id="element-313"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-314">
        <div className="text-center mb-16" data-id="element-315">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-316">
            Lo Que Dicen los Emprendedores Que Ya Dieron El Paso
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-317">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-brand-surface/80 backdrop-blur-sm border border-white/10 p-8 rounded-3xl flex flex-col" data-id="element-318">
              <Quote className="w-10 h-10 text-brand-accent/40 mb-6" data-id="element-319" />
              <p className="text-lg text-slate-300 italic mb-8 flex-grow" data-id="element-320">
                "{testimonial.quote}"
              </p>
              <div className="pt-6 border-t border-white/10" data-id="element-321">
                <p className="font-bold text-white" data-id="element-322">{testimonial.author}</p>
                <p className="text-sm text-brand-accent" data-id="element-323">
                  {testimonial.detail}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </Section>;
}